/**
 * Converts an amount from cents (or the smallest currency unit) to the main currency unit.
 * @param amountInCents - The amount in the smallest unit (e.g., cents).
 * @returns The amount in the main unit (e.g., dollars). Returns 0 if the input is not a valid number.
 */
export const formatCentsToCurrency = (
  amountInCents: number | undefined | null
): number => {
  if (typeof amountInCents !== 'number' || isNaN(amountInCents)) {
    return 0;
  }
  return amountInCents / 100;
};
